import React, { Component } from 'react';

import { StyleSheet } from 'react-native';

import { I18n, OPComponent, PlusMenu, PlusButton, Navigation } from '../components';

import { __WEB__, COLOR } from '../../constants/styles';

export default class AddMenu extends OPComponent {
  constructor(props) {
    super(props);
  }

  handleAddPress = () => {
    this.props.handleItemPress('calendar');
  };

  render() {
    if (this.props.isAirforce || this.props.isMedRecuiter) return null;
    if (!__WEB__) {
      return <PlusMenu onAddPress={this.handleAddPress} />;
    } else {
      return <PlusButton onPress={this.handleAddPress} />;
    }
  }
}

const styles = StyleSheet.create({});
